import * as Sentry from "@sentry/react";

export function connectSentry() {
  if (process.env.REACT_APP_ENV === "local") return;

  Sentry.init({
    environment: process.env.REACT_APP_ENV,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0
  });
}
